import React, { FC, SVGProps } from 'react';

const Google: FC<SVGProps<SVGSVGElement>> = props => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 22" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.06 11.25c0-.78-.07-1.53-.2-2.25H11.5v4.255h5.92a5.06 5.06 0 0 1-2.195 3.32v2.76h3.555c2.08-1.915 3.28-4.735 3.28-8.085Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 22c2.97 0 5.46-.985 7.28-2.665l-3.556-2.76c-.985.66-2.245 1.05-3.725 1.05-2.865 0-5.29-1.935-6.155-4.535H1.67v2.85A10.996 10.996 0 0 0 11.5 22Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.345 13.09A6.612 6.612 0 0 1 5 11c0-.725.125-1.43.345-2.09V6.06H1.67A10.996 10.996 0 0 0 .5 11c0 1.775.425 3.455 1.17 4.94l3.675-2.85Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 4.375c1.614 0 3.064.555 4.204 1.645l3.155-3.155C16.954 1.09 14.464 0 11.5 0 7.2 0 3.48 2.465 1.67 6.06l3.675 2.85c.865-2.6 3.29-4.535 6.155-4.535Z"
      fill="#EA4335"
    />
  </svg>
);

export default Google;
